// 토모플레이 - 지사 - 원별 사용량 메인 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";
import ReactEcharts from "echarts-for-react";

import { InputGroup } from "react-bootstrap";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";
import playStyle from "../components/style";

import CardStatContent from "../components/CardStatContent";

const cellRendererNumber = (val) => {
    return val ? val.toLocaleString() : "-"
};
const ContentBranch = forwardRef(({ branchList, selectedSubOption = 0, branchId=0, statPeriod, stat, updateViewSubOption, updateStat, onSelectNursery }, ref) => {
    const [subOptionApplied, setSubOptionApplied] = useState(false);
    const [tableData, setTableData] = useState(false);
    const [searchParam, setSearchParam] = useState({
        type: "",
        value: "",
    });

    const defaultColDef = {
        headerClass: "bg-dark text-light",
        cellClass: "text-center",
        minWidth: 70,
        width: 70,
        sortable: true,
        resizable: true,
        filter: false,
    };

    let listColumn = [
        {
            headerName: "No",
            field: "id",
            width: 45,
            minWidth: 45,
            valueGetter: "node.rowIndex + 1",
            pinned: "left",
        },
        {
            headerName: "지사 명",
            field: "branchName",
            minWidth: 125,
            width: 130,
            cellClass: "text-left",
            pinned: "left",
        },
        {
            headerName: "원 명",
            field: "nurseryUniqName",
            minWidth: 125,
            width: 130,
            cellClass: "text-left",
            filter: 
            {	
                displayKey: '포함',
                displayName: '원 명',
                test: function(filterValue, cellValue) {
                  if (cellValue == null) return false;
                  return cellValue.indexOf(filterValue) >= 0;
                },
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">계약<br/>반 수</div></div>`,
            },
            field: "contractCount",
            minWidth: 65,
            width: 65,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">계약<br/>원아 수</div></div>`,
            },
            field: "childContract",
            minWidth: 65,
            width: 65,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">등록<br/>원아 수</div></div>`,
            },
            field: "childRegist",
            minWidth: 65,
            width: 65,
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">총 수업<br/>시간(분)</div></div>`,
            },
            minWidth: 80,
            width: 80,
            valueGetter: (param) => {
                return param.data.playTimeTotal; // param.data.playTimeNormal + param.data.playTimeCollabo + param.data.playTimeAr;
            },
            cellRenderer: (param) => {
                return cellRendererNumber(param.value ? Math.round(param.value / 60) : param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">전체 콘텐츠<br/>실행 수</div></div>`,
            },
            headerClass: "bg-tomonote text-light",
            minWidth: 95,
            width: 95,
            sort: 'desc',
            valueGetter: (param) => {
                return param.data.divisionTotal; // param.data.divisionNuri + param.data.divisionCoding + param.data.divisionSubject + param.data.divisionImg + param.data.divisionYoutube + param.data.divisionCollabo + param.data.divisionAr;
            },
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">가정 전송<br/>콘텐츠 수</div></div>`,
            },
            headerClass: "bg-tomonote text-light",
            minWidth: 95,
            width: 95,
            field: "sendHomeCount",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">누리<br/>(누리+주제별)</div></div>`,
            },
            headerClass: "bg-momo-70 text-dark",
            minWidth: 104,
            width: 104,
            valueGetter: (param) => {
                return param.data.divisionNuriNSubjectEtc; // param.data.divisionNuri + param.data.divisionSubject - param.data.divisionEng - param.data.divisionKor;
            },
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerName: "코딩",
            headerClass: "bg-momo-70 text-dark",
            field: "divisionCoding",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerName: "영어",
            headerClass: "bg-momo-70 text-dark",
            field: "divisionEng",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerName: "한글",
            headerClass: "bg-momo-70 text-dark",
            field: "divisionKor",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerName: "이미지",
            headerClass: "bg-primary-dark text-light",
            field: "divisionImg",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerName: "유튜브",
            headerClass: "bg-primary-dark text-light",
            field: "divisionYoutube",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">협동<br/>그림</div></div>`,
            },
            headerClass: "bg-secondary text-light",
            field: "divisionCollabo",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">딩동<br/>AR</div></div>`,
            },
            headerClass: "bg-secondary text-light",
            field: "divisionAr",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">저작툴<br/>타입</div></div>`,
            },
            headerClass: "bg-tomoenglish text-dark",
            field: "contentType3",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">양방향<br/>타입</div></div>`,
            },
            headerClass: "bg-tomoenglish text-dark",
            field: "contentType1",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">활동지<br/>타입</div></div>`,
            },
            headerClass: "bg-tomoenglish text-dark",
            field: "contentType2",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
        {
            headerComponentParams: {
                template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">영상<br/>타입</div></div>`,
            },
            headerClass: "bg-tomoenglish text-dark",
            field: "contentType4",
            cellRenderer: (param) => {
                return cellRendererNumber(param.value);
            },
        },
    ];

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "플레이딩동_원별통계",
                sheets: [
                    {
                        name: "원",
                        title: `원별 콘텐츠 사용 통계`,
                        columnTitle: ["지사 명", "원 명", "계약 반 수", "계약 원아 수", "등록 원아 수", "총 수업시간(분)", `전체 콘텐츠 실행 수`, "가정 전송 콘텐츠 수", "누리(누리+주제별)", "코딩", "영어", "한글", "이미지", "유튜브", "협동그림", "딩동AR", "저작툴 타입", "양방향 타입", "활동지 타입", "영상 타입"],
                        data: tableData
                            ? tableData.map((s) => [s.branchName, s.nurseryUniqName, s.contractCount, s.childContract, s.childRegist, Math.round(s.playTimeTotal / 60), s.divisionTotal, s.sendHomeCount, s.divisionNuriNSubjectEtc, s.divisionCoding, s.divisionEng, s.divisionKor, s.divisionImg, s.divisionYoutube, s.divisionCollabo, s.divisionAr, s.contentType3, s.contentType1, s.contentType2, s.contentType4])
                            : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        selectedSubOption = selectedSubOption == null ? 0 : selectedSubOption;
        let isAll = selectedSubOption != 0 ? false : true;
        updateStat(null);
        setTableData(null);
        axios({
            method: "POST",
            url: `/api/playdd/stat/branch/${selectedSubOption}`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
                limit: -1,
                isAll: isAll
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    var statContracts = result.data.statContracts;
                    var stats = result.data.statNurseries;
                    var contractSummary = { contractNursery: 0, contractCount: 0, childContract: 0, childRegist: 0, statChildDataDate: result.data.statChildDataDate };
                    
                    if(statContracts && statContracts.length > 0) {
                        contractSummary.contractNursery = statContracts.length;
                        statContracts.forEach((n) => {
                            const s = stats.find((s) => n.nurseryUniqId == s.nurseryUniqId);
                            var findBranch = branchList.find((b) => b.id == n.branchId);

                            n.branchName = findBranch != undefined ? findBranch.name : "-";
                            if(s) {
                                Object.keys(s).forEach((k) => {
                                    n[k] = s[k];
                                });
                                n.playTimeTotal = s.playTimeNormal + s.playTimeCollabo + s.playTimeAr;
                                n.divisionTotal = s.divisionNuri + s.divisionCoding + s.divisionSubject + s.divisionImg + s.divisionYoutube;
                                n.divisionNuriNSubjectEtc = s.divisionNuri + s.divisionSubject - s.divisionEng - s.divisionKor;
                            }
                            contractSummary.contractCount += n.contractCount;
                            contractSummary.childContract += n.childContract;
                            contractSummary.childRegist += n.childRegist;
                        });
                    } else {
                        statContracts = [];
                    }

                    updateStat({stats: statContracts, contractSummary});
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }, [statPeriod, selectedSubOption]);

    useEffect(() => {
        if (!subOptionApplied) {
            if(updateViewSubOption && branchList && branchList.length > 0) {
                updateViewSubOption([{ name: "전체", id: 0 }].concat(branchList), 0);
                setSubOptionApplied(true);
            }
        }
        getStat();
        return () => {};
    }, [branchList]);

    useEffect(() => {
        if(selectedSubOption == null || !selectedSubOption) {
            selectedSubOption = 0;
        }
        getStat();
        return () => {};
    }, [subOptionApplied, statPeriod, selectedSubOption]);

    useEffect(() => {
        applyData(searchParam, stat ? stat.stats : []);

        return () => {};
    }, [stat]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, stat ? stat.stats : []);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);
        setTableData(tableData);
        setSearchParam(searchParam);
    };

    const searchField = ["nurseryUniqName"];
    const listSearch = (searchParam, list) => {
        var tableDataNew = [];
        if (!searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (item[field] && item[field].indexOf(searchParam.value) >= 0) {
                        tableDataNew.push(item);
                    }
                });
            });
        }
        return tableDataNew;
    };

    const onRowSelected = (e) => {
        if (onSelectNursery && e && e.data) {
            onSelectNursery(e.data.nurseryUniqId, e.data.nurseryUniqName, e.data.branchId);
        }
    };

    return (
        <div className="stat-branch-content">
            <div className="row">
                <div className="col text-right">
                    * 원아 자료 기준일: {stat && stat.contractSummary ? stat.contractSummary.statChildDataDate : '-'}
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row mb-5">
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                            <CardStatContent id="1" title={`계약 원`} titleTotal="" total={stat && stat.contractSummary ? stat.contractSummary.contractNursery : '-'} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                            <CardStatContent id="2" title={`계약 클래스`} titleTotal="" total={stat && stat.contractSummary ? stat.contractSummary.contractCount : '-'} titleBgClass="bg-tomoenglish" />
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatContent id="2" title={`계약 원아 수`} titleTotal="" total={stat && stat.contractSummary ? stat.contractSummary.childContract : '-'} titleBgClass="bg-tomobooks" />
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatContent id="2" title={`등록 원아 수`} titleTotal="" total={stat && stat.contractSummary ? stat.contractSummary.childRegist : '-'} titleBgClass="bg-tomoenglish" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-1">
                <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                    <h5 className="mb-0" style={{ alignSelf: "end" }}>
                        <span>
                            {tableData ? tableData.length : "0"} / {stat && stat.stats ? stat.stats.length : "0"}
                        </span>
                    </h5>
                </div>
                <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12">
                    <InputGroup className="input-group my-group">
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder="원 명"
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        defaultColDef={defaultColDef}
                        columnDefs={listColumn}
                        headerHeight={45}
                        rowData={tableData}
                        height={550}
                        onRowClicked={(e) => {
                            onRowSelected(e);
                        }}
                        pagination={true}
                        overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`}
                    />
                </div>
            </div>
        </div>
    );
});

export default ContentBranch;
